import { css } from "@emotion/react";
import { Dropdown } from "primereact/dropdown";
import { AuthContextType, useAuth } from "../../auth/auth-provider";

export interface WorkspaceBarProps {
  workspace?: number | null;
  onWorkspaceChange: (workspace: number | null) => void;
}

const WorkspaceBar = ({ workspace, onWorkspaceChange }: WorkspaceBarProps) => {
  const { user } = useAuth() as AuthContextType;
  const workspaceOptions = user.workspaces?.workspaces ?? [];

  return (
    <div
      css={css`
        display: flex;
        padding: 8px 12px;
        border-bottom: 1px solid #282d35;
      `}
    >
      <Dropdown
        css={css`
          width: 100%;
          height: 32px;
          border: 1px solid #2f343d;
          background-color: #2f343d;
          color: #ffffff;
          display: flex;
          align-items: center;

          .p-dropdown-label {
            color: #ffffff;
            padding: 4px 0 !important;
            line-height: 1.2;
            display: flex;
            align-items: center;
          }

          .p-dropdown-label.p-placeholder {
            color: #ffffff;
          }

          .p-dropdown-trigger {
            width: 24px;
          }

          &:not(.p-disabled):hover {
            border-color: #2f343d;
            color: #ffffff;
          }
        `}
        placeholder="Workspaces"
        options={workspaceOptions}
        optionLabel="name"
        optionValue="id"
        value={workspace}
        onChange={(e) => onWorkspaceChange(e.value)}
        showClear
        filter
      />
    </div>
  );
};

export default WorkspaceBar;
